import React, { useEffect, useLayoutEffect, useRef } from "react";
import Title from "../components/Title";
import { Link } from "react-router-dom";
import CustomButton from "../components/CustomButton";
import arrowLeft from "../images/arrowLeft.svg";
import Footer from "../components/Footer";
import { checkAndSetStats } from "../helpers/helpers";

function NotFound() {
    const doesStatsSent = useRef(false);

    useLayoutEffect(() => {
        document.body.style.backgroundColor = "#1d1d1d";
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    }, []);

    useEffect(() => {
        if (!doesStatsSent.current) {
            checkAndSetStats("errorPage");
            doesStatsSent.current = true;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="text-center mt-8 h-screen flex flex-col justify-between">
            <div>
                <Title
                    classNames={"text-white"}
                    title={"Сторінку не знайдено"}
                />
                <div className="flex justify-center">
                    <Link to="/">
                        <CustomButton
                            title={"Переглянути інші колекції"}
                            iconBefore={() => (
                                <img
                                    className="mr-4 h-4"
                                    src={arrowLeft}
                                    alt="<"
                                />
                            )}
                            className={`text-base hover:bg-transparent lg:text-[22px] mt-4 w-fit`}
                        />
                    </Link>
                </div>
            </div>

            <Footer containerClassNames={"bg-white pb-4"} />
        </div>
    );
}

export default NotFound;
